import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Reveal from "../components/Reveal";

function Contact() {
  const [mapLoaded, setMapLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMapLoaded(true), 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <main className="bg-[var(--bg)] text-[var(--bone)] pt-32 pb-24">
      {/* HERO */}
      <section className="px-5 md:px-10">
        <div className="max-w-7xl mx-auto grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-3">
            <Reveal>
              <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--clay)]">
                — Find us
              </div>
              <div className="mt-3 font-display text-5xl md:text-7xl text-[var(--bone)]">
                /Map
              </div>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-9">
            <Reveal delay={120}>
              <h1 className="font-display font-light text-[clamp(2.5rem,6.5vw,6rem)] leading-[1] tracking-tight">
                The studio is in{" "}
                <span className="italic font-extralight">South Delhi</span>.
              </h1>
            </Reveal>
            <Reveal delay={240}>
              <p className="mt-10 max-w-2xl text-[var(--muted)] text-[17px] leading-relaxed">
                Drop by for chai, a portfolio review, or a long conversation
                about the wall you have in mind. We work by appointment — but
                we're rarely hard to reach.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      {/* DETAILS */}
      <section className="px-5 md:px-10 mt-24 md:mt-32">
        <div className="max-w-7xl mx-auto grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-4">
            <Reveal>
              <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--clay)] mb-4">
                — Address
              </div>
              <p className="font-display text-2xl md:text-3xl text-[var(--bone)] leading-tight">
                F-10/22 Ground floor,
                <br />
                near Moosa Apt., Joga Bai Ext.,
                <br />
                Jamia Nagar,
                <br />
                South Delhi 110025
              </p>
            </Reveal>
          </div>

          <div className="col-span-12 md:col-span-4 md:pl-8 md:border-l md:border-[var(--line)]">
            <Reveal delay={120}>
              <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--clay)] mb-4">
                — Reach us
              </div>
              <ul className="space-y-5">
                <li>
                  <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--muted)]">
                    Phone
                  </div>
                  <a
                    href="tel:+919911499221"
                    className="block mt-1 font-display text-xl md:text-2xl text-[var(--bone)] hover:text-[var(--clay)] transition-colors"
                  >
                    +91 99114 99221
                  </a>
                </li>
                <li>
                  <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--muted)]">
                    Alternate
                  </div>
                  <a
                    href="tel:+919560615712"
                    className="block mt-1 font-display text-xl md:text-2xl text-[var(--bone)] hover:text-[var(--clay)] transition-colors"
                  >
                    +91 95606 15712
                  </a>
                </li>
                <li>
                  <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--muted)]">
                    Email
                  </div>
                  <a
                    href="mailto:tabaartist@gmail.com"
                    className="block mt-1 font-display text-xl md:text-2xl text-[var(--bone)] hover:text-[var(--clay)] transition-colors"
                  >
                    tabaartist@gmail.com
                  </a>
                </li>
                <li className="pt-2 flex items-center gap-3">
                  <a
                    href="https://wa.me/919911499221"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-5 py-3 bg-[var(--clay)] text-[var(--bone)] rounded-full text-sm tracking-wide hover:bg-[var(--bone)] hover:text-[var(--ink)] transition-colors"
                  >
                    WhatsApp us
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M5 12h14M13 5l7 7-7 7" />
                    </svg>
                  </a>
                </li>
              </ul>
            </Reveal>
          </div>

          <div className="col-span-12 md:col-span-4 md:pl-8 md:border-l md:border-[var(--line)]">
            <Reveal delay={240}>
              <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--clay)] mb-4">
                — Hours
              </div>
              <ul className="space-y-5">
                <li>
                  <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--muted)]">
                    Studio open
                  </div>
                  <div className="mt-1 font-display text-xl md:text-2xl text-[var(--bone)]">
                    Mon — Sat
                  </div>
                  <div className="text-[var(--muted)] text-sm">
                    10:00 — 19:00 IST
                  </div>
                </li>
                <li>
                  <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--muted)]">
                    On-site (wall days)
                  </div>
                  <div className="mt-1 font-display text-xl md:text-2xl text-[var(--bone)]">
                    By commission
                  </div>
                  <div className="text-[var(--muted)] text-sm">
                    Delhi NCR + travel
                  </div>
                </li>
                <li>
                  <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--muted)]">
                    Response time
                  </div>
                  <div className="mt-1 font-display text-xl md:text-2xl text-[var(--bone)]">
                    Within 24 hours
                  </div>
                </li>
              </ul>
            </Reveal>
          </div>
        </div>
      </section>

      {/* MAP */}
      <section className="px-5 md:px-10 mt-24 md:mt-32">
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--clay)] mb-6 flex items-center gap-3">
              <span className="w-8 h-px bg-[var(--clay)]" />
              28.5° N · 77.2° E — Jamia Nagar, New Delhi
            </div>
          </Reveal>
          <Reveal delay={120}>
            <div className="relative aspect-[16/9] md:aspect-[21/9] w-full overflow-hidden bg-[var(--bg-soft)] editorial-frame">
              {!mapLoaded && (
                <div className="absolute inset-0 grid place-items-center">
                  <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.32em] text-[var(--muted)]">
                    <span className="w-2 h-2 rounded-full bg-[var(--clay)] animate-pulse" />
                    Loading the studio…
                  </div>
                </div>
              )}
              {mapLoaded && (
                <iframe
                  title="TABA studio location — Jamia Nagar, South Delhi"
                  src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3504.0490834867182!2d77.28046917549848!3d28.56828877569995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjjCsDM0JzA1LjgiTiA3N8KwMTYnNTkuMCJF!5e0!3m2!1sen!2sin!4v1704347107175!5m2!1sen!2sin"
                  className="w-full h-full"
                  style={{ border: 0, filter: "grayscale(80%) contrast(1.05)" }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              )}
              {/* Frame corners */}
              <span className="absolute top-3 left-3 w-3 h-3 border-t border-l border-[var(--clay)]" />
              <span className="absolute top-3 right-3 w-3 h-3 border-t border-r border-[var(--clay)]" />
              <span className="absolute bottom-3 left-3 w-3 h-3 border-b border-l border-[var(--clay)]" />
              <span className="absolute bottom-3 right-3 w-3 h-3 border-b border-r border-[var(--clay)]" />
            </div>
          </Reveal>
        </div>
      </section>

      {/* CTA */}
      <section className="px-5 md:px-10 mt-24 md:mt-40">
        <div className="max-w-7xl mx-auto border-t border-[var(--line)] pt-12 flex flex-col md:flex-row items-start md:items-end justify-between gap-6">
          <div>
            <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--clay)]">
              — Have a wall?
            </div>
            <h3 className="mt-3 font-display text-3xl md:text-5xl text-[var(--bone)] leading-tight max-w-xl">
              Ready to start the conversation?
            </h3>
          </div>
          <Link
            to="/booknow"
            className="group inline-flex items-center gap-3 px-7 py-4 bg-[var(--clay)] text-[var(--bone)] rounded-full tracking-wide hover:bg-[var(--bone)] hover:text-[var(--ink)] transition-colors"
          >
            Book a mural
            <span className="relative w-4 h-4 overflow-hidden">
              <span className="absolute inset-0 transition-transform duration-500 group-hover:translate-x-5 group-hover:-translate-y-5">
                →
              </span>
              <span className="absolute inset-0 -translate-x-5 translate-y-5 transition-transform duration-500 group-hover:translate-x-0 group-hover:translate-y-0">
                →
              </span>
            </span>
          </Link>
        </div>
      </section>
    </main>
  );
}

export default Contact;